import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import CardIndex from '../../card/CardIndex/CardIndex';
import Loading from '../../components/Loading/Loading';
import { getQueryString } from '../../utils/utils';
import DetailComment from '../../components/Detail/DetailComment';
import DetailCommentList from '../../components/Detail/DetailCommentList';
import styles from './OSpecial.module.less';

export default memo(({ specialInfo, recommZT }) => {
  const location = useLocation();
  const ztId = getQueryString('ztId', location.search) || '';

  return (
    <>
      <div className={styles.special}>
        {specialInfo &&
        specialInfo.ztList &&
        specialInfo.ztList.length > 0 &&
        specialInfo.ztId === ztId ? (
          specialInfo.ztList.map((item, i) => (
            <React.Fragment key={i}>
              <CardIndex data={item} key={i} logInfo={{ tag: 'Special' }} />
            </React.Fragment>
          ))
        ) : (
          <div className={styles.special_loading}>
            <Loading />
          </div>
        )}
      </div>
      {specialInfo &&
        specialInfo.ztId &&
        specialInfo.ztType &&
        recommZT &&
        recommZT.map((item, index) => {
          return (
            <CardIndex
              data={{ ...item, ztType: specialInfo.ztType || '' }}
              key={index}
              logInfo={{ tag: 'Special' }}
            />
          );
        })}
      <div>
        {specialInfo && specialInfo.ztCommentId && (
          <>
            <div className={styles.comment}>
              <DetailComment
                appDetailsData={specialInfo}
                source="zt"
                text="写点评论吧"
                maxLength={800}
              />
            </div>
            <DetailCommentList appDetailsData={specialInfo} source="zt" />
          </>
        )}
      </div>
    </>
  );
});
